module.exports = __webpack_public_path__ + "img/32.fedf68ae.jpg";